

























import Vue from 'vue';
import { Expression, ChainExpression, NotExpression, NoExpression } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';


export default ExpressionBase<NotExpression>().extend({
  name: 'NotEditor',
  methods: {
    updateExpression(expr?: Expression) {
      this.value.expression = expr || NoExpression.instance;
      this.update();
    },
  },
});
